import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

const LEGACY_LS_KEY = 'seo.slugs.v1';

/**
 * Retired slug catalogue. SEO route admission is decided only by the full-path resolve API
 * (BLA-54 C06), so this service no longer fetches, caches or answers anything. Its initializer
 * removes the obsolete browser catalogue so an old slug list can never influence routing.
 */
@Injectable({ providedIn: 'root' })
export class SeoPageSlugCacheService {
  constructor(@Inject(PLATFORM_ID) private readonly platformId: object) {}

  public initialize(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      try {
        localStorage.removeItem(LEGACY_LS_KEY);
      } catch {
        // Storage unavailable (privacy mode): nothing to clean up.
      }
    }
    return Promise.resolve();
  }
}
